'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';

var ScorePercentWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n"], ["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n"])), function (_a) {
    var diameter = _a.diameter;
    return diameter;
}, function (_a) {
    var diameter = _a.diameter;
    return diameter;
});
var LabelPercent = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    margin: 0;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    margin: 0;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n"])), function (_a) {
    var sizes = _a.sizes;
    return sizes;
}, function (_a) {
    var sizes = _a.sizes;
    return sizes;
}, function (_a) {
    var label = _a.label;
    return label.weight;
}, function (_a) {
    var label = _a.label;
    return label.size;
}, function (_a) {
    var label = _a.label;
    return label.lineHeight;
}, function (_a) {
    var color = _a.color;
    return color;
});
var LabelExtend = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n"], ["\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n"])));
var CircleItem = styled.circle(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    stroke-dashoffset: ", ";\n    transform: rotate(-90deg);\n    transform-origin: 0px 0px;\n    fill-opacity: 0;\n    transition: ", ";\n\n    ", "\n"], ["\n    stroke-dashoffset: ", ";\n    transform: rotate(-90deg);\n    transform-origin: 0px 0px;\n    fill-opacity: 0;\n    transition: ", ";\n\n    ", "\n"])), function (_a) {
    var strokeDashoffset = _a.strokeDashoffset;
    return strokeDashoffset;
}, function (_a) {
    var duration = _a.duration, delay = _a.delay;
    return "stroke-dashoffset ".concat(duration, "ms ease-out ").concat(delay, "ms,\n    stroke-dasharray ").concat(duration, "ms ease ").concat(delay, "ms, stroke ").concat(duration, "ms ease ").concat(delay, "ms,\n        stroke-width 0.06s ease ").concat(delay, "ms, opacity ").concat(duration, "ms ease ").concat(delay, "ms");
}, function (_a) {
    var customStrokeDashArray = _a.customStrokeDashArray;
    if (!customStrokeDashArray) {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                stroke-dasharray: ", ";\n            "], ["\n                stroke-dasharray: ", ";\n            "])), function (_a) {
            var perimeter = _a.perimeter;
            return "".concat(perimeter, "px, ").concat(perimeter, "px");
        });
    }
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            stroke-dasharray: ", ";\n        "], ["\n            stroke-dasharray: ", ";\n        "])), function (_a) {
        var customStrokeDashArray = _a.customStrokeDashArray;
        return "".concat(customStrokeDashArray);
    });
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { CircleItem, LabelExtend, LabelPercent, ScorePercentWrapper };
//# sourceMappingURL=AICircleProgressBar.css.js.map
